import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { TextField, Button, Box, Typography } from '@mui/material';
import { addExpense } from '../redux/expenseSlice';

const ExpenseForm = () => {
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const dispatch = useDispatch();

  // Get current date and time (as per system message: 01:13 PM IST on Saturday, June 14, 2025)
  const currentDateTime = new Date();
  const formattedDateTime = currentDateTime.toLocaleString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata', // IST timezone
  }) + ' IST';

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      addExpense({
        amount: parseFloat(amount),
        description,
        category,
        status: amount > 1000 ? 'Pending' : 'Approved', // Auto-approval logic
        date: formattedDateTime, // Include the date in the expense data
      })
    );
    setAmount('');
    setDescription('');
    setCategory('');
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Submit Expense
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Amount"
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Category"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Submission Date"
          value={formattedDateTime}
          fullWidth
          margin="normal"
          disabled
          InputProps={{
            readOnly: true,
          }}
          sx={{
            '& .MuiInputBase-root.Mui-disabled': {
              bgcolor: 'rgba(0, 0, 0, 0.05)', // Subtle background for disabled field
              color: 'text.primary', // Ensure text is readable
            },
            '& .MuiInputLabel-root.Mui-disabled': {
              color: 'text.secondary', // Label color for disabled field
            },
          }}
        />
        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
          Submit
        </Button>
      </form>
    </Box>
  );
};

export default ExpenseForm;